import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfPaquetesOrdenes } from '@/modules/Contratacion/interfaces'

export class PaqueteService extends BaseService<IConfPaquetesOrdenes> {
  constructor () {
    super({
      baseUrl: 'system/order-packages/'
    })
  }
}
